import React from 'react';

import {UPLOAD_FILE_MAX_SIZE_LIMIT_MB, UPLOAD_FILE_VALID_EXTENSIONS} from 'src/modules/create-user/constants';

import {Group} from '@pb/kit-component-group';
import Icon, {Icons} from '@pb/kit-component-icon';

import {dropZoneViewServiceIcon} from './drop-zone-view.module.styl';

type Props = {
    addedFile: File | null,
    maxRecords?: number,
};

const getUploadFileExtensionsLine = (): string => (
    UPLOAD_FILE_VALID_EXTENSIONS.map(item => item.slice(1).toUpperCase()).join(', ')
);

export const DropZoneView = ({addedFile, maxRecords}: Props) => {

    if (addedFile) {
        return (
            <div style={{width: 900}}>
                <Group direction="v" gap="s">
                    <Icon className={dropZoneViewServiceIcon} type={Icons.CHECK_CIRCLE}/>
                    <div>Completed</div>
                </Group>
            </div>
        );
    }
    return (
        <div style={{width: 900}}>
            <Group direction="v" gap="xxs">
                <Icon className={dropZoneViewServiceIcon} type={Icons.UPLOAD}/>
                <span>Drag & drop a file to upload or <a>browse</a></span>
                <span className="font-size font-size_footer">
                    {
                        `Max. users count: ${maxRecords ? maxRecords : UPLOAD_FILE_MAX_SIZE_LIMIT_MB} records.
                        Accepted formats: ${getUploadFileExtensionsLine()}`
                    }
                </span>
            </Group>
        </div>

    );
};
